import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import Hero from '../components/Hero';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import PrivacyImg from '../assets/images/hero-privacy.jpg';

export default function Privacy() {
  const m = meta.privacy;
  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero title="Privacy Policy" subtitle="How we collect, use, and protect your information." bgImage={PrivacyImg} />
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography paragraph>
          We collect only the information needed to deliver HVAC services—contact details, service address, and basic system info.
          We never sell personal data. We use analytics to improve our site. You may request deletion of data by emailing
          info@ritehvacservices.com.
        </Typography>
      </Container>
    </Box>
  );
}
